import React, { FC, useCallback, useState } from 'react'
import { Form } from 'react-bootstrap'
import styled from 'styled-components'

import { $white, $primary } from 'utils/colors'

const S = {
    LogoUpload: styled.div`
        display: flex;
        flex-direction: row;
    `,
    LogoUploadInput: styled.div`
        flex-grow: 1;
        flex-shrink: 1;
        text-align: right;
    `,
    LogoUploadInputText: styled.div`
        position: relative;
        cursor: pointer;
        font-size: 14px;
        line-height: 16px;
        color: ${$primary};
        text-decoration: underline;
        margin-top: 8px;

        input {
            opacity: 0;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
        }
    `,
    LogoUploadImage: styled.div`
        display: flex;
        width: 60px;
        height: 60px;

        background: ${$white};
        border: 1px dashed rgba(24, 28, 33, 0.15);
        box-sizing: border-box;
        border-radius: 4px;
        overflow: hidden;
        padding: 5px;

        align-items: center;
        justify-content: center;
        flex-grow: 0;
        flex-shrink: 0;

        margin-left: 20px;

        img {
            width: 100%;
            height: auto;
            margin: auto;
        }
    `,
}

export interface EditableImageFieldProps {
    defaultValue: string
    label: string
    replaceLinkText: string
    onUpdate(file: File): void
}

const EditableImageField: FC<EditableImageFieldProps> = ({
    defaultValue,
    label,
    replaceLinkText,
    onUpdate,
}: EditableImageFieldProps) => {
    const [uploadedFile, setUploadedFile] = useState<string>()

    const fileUploadChangeHandler = useCallback(
        (event) => {
            if (event.target.files.length > 0) {
                const file: File = event.target.files[0]
                setUploadedFile(URL.createObjectURL(file))
                onUpdate(file)
            }
        },
        [onUpdate]
    )

    return (
        <Form.Group>
            <S.LogoUpload>
                <S.LogoUploadInput>
                    <Form.Label htmlFor="company_logo">{label}</Form.Label>
                    <S.LogoUploadInputText>
                        {replaceLinkText}
                        <Form.Control
                            type="file"
                            onChange={fileUploadChangeHandler}
                        />
                    </S.LogoUploadInputText>
                </S.LogoUploadInput>
                <S.LogoUploadImage>
                    <img src={uploadedFile || defaultValue} alt="" />
                </S.LogoUploadImage>
            </S.LogoUpload>
        </Form.Group>
    )
}

export default EditableImageField
